/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import './Banner.css';
import { useHistory } from "react-router-dom";

const Banner = () => {
    const History = useHistory();
    return (
    <>
        <section className="banner" >
            <img src="Bannerposodonto.png" className="responsive" alt="Posodonto"></img>
                <img src="Bannerposodontomobile.png" className="mobile" alt="Posodontomobile" hidden></img>
            <div className="conteudogeral">
                <div className="info">
                    <img src="muito.png" className="desktopmuito" id="mobilemuito" alt="muitomais"></img><br/>
                    <img src="itcodontologica.png" className="desktopinovacao" id="mobileinovacao" alt="inovacao"></img>
                    {/* <h1 className="M">MUITO+</h1>
                        <h3 className="I">INOVAÇÃO E TECNOLOGIA</h3>
                        <h3 className="N">NA SUA CARREIRA</h3>
                        <h3 className="O">ODONTOLOGICA</h3> */}
                </div>
                
                <div className="especializacao">
                    <button className="btn1" onClick={() => {History.push("/endodontia");}}><h4>ESPECIALIZAÇÃO EM ENDODONTIA</h4></button>
                    <button className="btn2" onClick={() => {History.push("/imaginologia");}}><h4>ESPECIALIZAÇÃO EM RADIOLOGIA IMAGINOLOGIA</h4></button>
                    <button className="btn3" onClick={() => {History.push("/implantodontia");}}><h4>ESPECIALIZAÇÃO EM IMPLANTODONTIA</h4></button><br/>
                    <button className="btn4" onClick={() => {History.push("/pacientesespeciais");}}><h4>ESPECIALIZAÇÃO EM ODONTOLOGIA PARA PACIENTES COM NECESSIDADES ESPECIAIS</h4></button>
                </div>
            </div>
        </section>
    </>  
    )
}

export default Banner;